import API from "../API/main";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialJobState = {
  isLoading: false,
  jobs: null,
  job: null,
  error: null,
  statuses: null,
  locations: null,
  employmentTypes: null,
};

export const getJobStatuses = createAsyncThunk("jobs/job/statuses", async (_, thunkAPI) => {
  const response = await API.JobsAPI.getStatuses();
  if (!!response.error) {
    return thunkAPI.rejectWithValue(response.error);
  }
  return response;
});

export const getJobLocations = createAsyncThunk("jobs/job/locations", async (_, thunkAPI) => {
  const response = await API.JobsAPI.getLocations();
  if (!!response.error) {
    return thunkAPI.rejectWithValue(response.error);
  }
  return response;
});

export const getEmploymentTypes = createAsyncThunk(
  "jobs/job/employment-types",
  async (_, thunkAPI) => {
    const response = await API.JobsAPI.getEmploymentTypes();
    if (!!response.error) {
      return thunkAPI.rejectWithValue(response.error);
    }
    return response;
  }
);

export const getJobs = createAsyncThunk("jobs/all", async (data, thunkAPI) => {
  const response = await API.JobsAPI.getJobs(data);
  if (!!response.error) {
    return thunkAPI.rejectWithValue(response.error);
  }
  return response;
});

export const getJob = createAsyncThunk("jobs/job", async (id, thunkAPI) => {
  const response = await API.JobsAPI.getJob(id);
  if (!!response.error) {
    return thunkAPI.rejectWithValue(response.error);
  }
  return response;
});

export const suggestJob = createAsyncThunk("jobs/suggest", async (data, thunkAPI) => {
  const response = await API.JobsAPI.suggestJob(data);
  if (!!response.error) {
    return thunkAPI.rejectWithValue(response.error);
  }
  return response;
});

const jobSlice = createSlice({
  initialState: initialJobState,
  name: "job",
  reducers: {
    clearJobs(state) {
      state.jobs = initialJobState.jobs;
    },
  },
  extraReducers: {
    [getJobStatuses.pending]: (state) => {
      state.isLoading = true;
    },
    [getJobStatuses.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.statuses = action.payload;
      state.error = null;
    },
    [getJobStatuses.rejected]: (state, action) => {
      state.isLoading = false;
      state.error = action.error || action.payload;
    },
    [getJobLocations.pending]: (state) => {
      state.isLoading = true;
    },
    [getJobLocations.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.locations = action.payload;
      state.error = null;
    },
    [getJobLocations.rejected]: (state, action) => {
      state.isLoading = false;
      state.error = action.error || action.payload;
    },
    [getEmploymentTypes.pending]: (state) => {
      state.isLoading = true;
    },
    [getEmploymentTypes.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.employmentTypes = action.payload;
      state.error = null;
    },
    [getEmploymentTypes.rejected]: (state, action) => {
      state.isLoading = false;
      state.error = action.error || action.payload;
    },
    [getJobs.pending]: (state) => {
      state.isLoading = true;
    },
    [getJobs.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.jobs = action.payload;
      state.error = null;
    },
    [getJobs.rejected]: (state, action) => {
      state.isLoading = false;
      state.error = action.error || action.payload;
    },
    [getJob.pending]: (state) => {
      state.isLoading = true;
    },
    [getJob.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.job = action.payload;
      state.error = null;
    },
    [getJob.rejected]: (state, action) => {
      state.isLoading = false;
      state.error = action.error || action.payload;
    },
    [suggestJob.pending]: (state) => {
      state.isLoading = true;
    },
    [suggestJob.fulfilled]: (state) => {
      state.isLoading = false;
      state.error = null;
    },
    [suggestJob.rejected]: (state, action) => {
      state.isLoading = false;
      state.error = action.error || action.payload;
    },
  },
});

export const { clearJobs } = jobSlice.actions;
export default jobSlice.reducer;
